import { createMarkup } from '@packages/domain/utils/createMarkup/createMarkup';
import { useEffect } from 'react';
import './Notification.scss';

const TTL_TIME = 5000;

type NotificationProps = {
  message: string;
  type: 'error' | 'info' | 'success';
  onClose?: () => void;
};

export const Notification = ({ message, type, onClose }: NotificationProps) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      onClose?.();
    }, TTL_TIME);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [onClose]);

  return (
    <div className={`Notification Notification--${type}`}>
      <div
        role="alert"
        className="Notification-message"
        dangerouslySetInnerHTML={createMarkup(message)}
      />
    </div>
  );
};
